import { useProduct } from '@revenuewell/front-end-bundle';
import { PatientActions } from 'apps/wrapper/src/components/shared/contact/patient-actions/patient-actions';
import { useEventBus } from 'apps/wrapper/src/hooks/use-event-bus';
import { EventJumpToMessage } from 'apps/wrapper/src/types/event-bus';
import moment from 'moment';
import { useCallback } from 'react';
import { usePatientProfile } from '../../../../../../hooks/use-patient-profile/use-patient-profile';
import { formatPhoneNumber } from '../../../../../../utils/formatter';
import { DotSeparator } from '../../../../../shared/dot-separator/dot-separator.styles';
import { usePatientProfileWidget } from '../../hooks/use-patient-profile-widget';
import { WidgetRoutePath } from '../../navigation/route-config';
import { PatientDetails, PatientInfo, PatientInfoWrapper, PatientName, PatientRp } from './contact-info.styles';

export const ContactInfo = () => {
  const { hasProduct } = useProduct();
  const { publish } = useEventBus();
  const { contactDetails, locationId } = usePatientProfile();
  const { contactsByPhone, goTo } = usePatientProfileWidget();

  const getPhoneNumber = (contactDetails: any) => {
    if (contactDetails.cellPhone) return formatPhoneNumber(contactDetails.cellPhone);
    else if (contactDetails.homePhone) return formatPhoneNumber(contactDetails.homePhone);
    else if (contactDetails.workPhone) return formatPhoneNumber(contactDetails.workPhone);
    return '';
  };

  const getContactName = useCallback(() => {
    let name = `${contactDetails.firstName} ${contactDetails.lastName}`;
    if (contactsByPhone?.length > 1) return (name += ' + Others');
    return name;
  }, [contactDetails, contactsByPhone]);

  const getPatientDetails = useCallback(() => {
    const components = [
      {
        component: contactDetails.isResponsibleParty ? <PatientRp>RP</PatientRp> : null,
        divider: null
      },
      {
        component: contactDetails.dateOfBirth ? moment(contactDetails.dateOfBirth).format('MM/DD/YYYY') : null,
        divider: <DotSeparator />
      },
      {
        component: getPhoneNumber(contactDetails),
        divider: <DotSeparator />
      }
    ];

    return components
      .filter((component) => component.component != null)
      .reduce((acc: any, component, index, array) => {
        if (index === array.length - 1) return acc.concat(component.component);
        if (component.divider) return acc.concat(component.component, component.divider);
        return acc.concat(component.component);
      }, []);
  }, [contactDetails]);

  const handleMessengerClick = (patientId: number) => {
    if (hasProduct('messenger')) {
      publish({
        messageType: 'jumpToMessage',
        data: {
          patientId: patientId
        } as EventJumpToMessage['data']
      });
    } else {
      goTo(WidgetRoutePath.INBOX);
    }
  };

  return (
    <>
      {contactDetails && (
        <PatientInfoWrapper>
          <PatientInfo>
            <PatientName>
              {`${getContactName()}${
                contactDetails.dateOfBirth ? `, ${moment().diff(contactDetails.dateOfBirth, 'years', false)}` : ''
              }`}
            </PatientName>
            <PatientDetails>{getPatientDetails()}</PatientDetails>
          </PatientInfo>
          <PatientActions contact={contactDetails} locationId={locationId} onMessengerClick={handleMessengerClick} />
        </PatientInfoWrapper>
      )}
    </>
  );
};
